// @import_dependencies
// @end

// @import services
import zones, { ITimeZoneOption, TimeZone } from './zones'
import cultures from './cultures'
import timezones from './zones'
// @end

// @import utilities
// @end

// @import types
// @end

class TimezoneService {

  private listOfZones: Array<Object>
  private listOfCultures: Array<Object>

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.listOfZones = zones
    this.listOfCultures = cultures
  }

  getAllZones() {
    return this.listOfZones
  }

  getAllCultures() {
    return this.listOfCultures
  }

  public getCurrentTimezone = (): ITimeZoneOption | undefined => {
    const currentDate = new Date()
    const offset = currentDate.getTimezoneOffset()
    const currentGMT = `GMT-${Math.trunc(offset/60)}` as TimeZone
    return timezones.find((timezone) => timezone.value === currentGMT)
  }
}

export default TimezoneService
